import styled from "styled-components";
import { motion } from "framer-motion";


interface CrossIconProps {
  onClick: () => void;
  screenNumber: number;
}

export const CrossIcon = ({ onClick, screenNumber }: CrossIconProps) => {
  return (
    <CrossIconStyled whileHover={{ scale: 1.08 }} whileTap={{ scale: 0.98 }}>
      <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
      >
        <path
          d="m13.41 12 4.3-4.29a1.004 1.004 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1.004 1.004 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l4.29-4.3 4.29 4.3a1.002 1.002 0 0 0 1.639-.325 1 1 0 0 0-.219-1.095L13.41 12Z"
          fill={(screenNumber === 0) ? "#FFFFFF" : "#000000"}
        />
      </svg>
    </CrossIconStyled>
  );
};

const CrossIconStyled = styled(motion.div)`
  position: absolute;
  right: 12px;
  top: 10px;
  cursor: pointer;
`;
